// src/components/MatchDetailModal.js
import React, { useState } from 'react';
import MatchDetail from './MatchDetail';
import '../styles/MatchDetailModal.css';

/**
 * Modal wrapper for MatchDetail component
 * Can be used from anywhere to show match details in an overlay
 */
const MatchDetailModal = ({ matchId, teamName, isOpen, onClose }) => {
    if (!isOpen) return null;

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    const handleClose = () => {
        onClose();
    };

    return (
        <div className="match-detail-modal-backdrop" onClick={handleBackdropClick}>
            <div className="match-detail-modal-content">
                <button className="match-detail-modal-close" onClick={handleClose} aria-label="Close">
                    ×
                </button>
                <div className="match-detail-modal-body">
                    <MatchDetail
                        matchId={matchId}
                        teamName={teamName}
                        onBack={handleClose}
                    />
                </div>
            </div>
        </div>
    );
};

/**
 * Hook to manage match detail modal state
 * Usage:
 * const matchDetailModal = useMatchDetailModal();
 * matchDetailModal.open(matchId, teamName);
 * <MatchDetailModal {...matchDetailModal.props} />
 */
export const useMatchDetailModal = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [matchId, setMatchId] = useState(null);
    const [teamName, setTeamName] = useState('');

    const open = (id, team) => {
        setMatchId(id);
        setTeamName(team);
        setIsOpen(true);
    };

    const close = () => {
        setIsOpen(false);
        // Don't clear matchId/teamName immediately to allow for exit animations
        setTimeout(() => {
            setMatchId(null);
            setTeamName('');
        }, 300);
    };

    return {
        open,
        close,
        props: {
            isOpen,
            matchId,
            teamName,
            onClose: close
        }
    };
};

export default MatchDetailModal;
